import { render } from "./404.vue?vue&type=template&id=26164d27&scoped=true"
const script = {}

import "./404.vue?vue&type=style&index=0&id=26164d27&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-26164d27"

export default script